import React from "react";
import { DtoRoutesDefinition } from "../Dto/auth";

import LoginPage from "../Pages/AuthPages/LoginPage";
import UserSignUp from "../Pages/AuthPages/UserSignUp";
import Dashboard from "../Pages/HomePages/Dashboard";
import Categories from "../Pages/Categories/Categories";
import Service from "../Pages/Service/service";
import Providers from "../Pages/Providers/Providers";
import Bookings from "../Pages/Bookings/Bookings";
import Subcategory from "../Pages/SubCategories/SubCategory";
import Customermanagement from "../Pages/CustomerManagement/Customermanagement";
import CustomerDetails from "../Pages/CustomerManagement/CustomerDetails";
import BookingDetails from "../Pages/Bookings/BookingDetails";
import ProviderFormWrapper from "../Pages/Providers/ProviderFormWrapper";
import BookingsWrapper from "../Pages/Providers/BookingsWrapper";
import BannerManagement from "../Pages/BannerManagement/BannerManagement";
import CouponManagement from "../Pages/CouponManagement/CouponManagement";
import PaymentManagement from "../Pages/PaymentManagement/PaymentManagement";




export const ProtectedRoutes: DtoRoutesDefinition[] = [
    {
        path: "/dashboard",
        element: <Dashboard />,
    },
    {
        path: "/categories",
        element: <Categories />,
    },
    {
        path: "/categories/add",
        element: <Categories />,
    },
    {
        path: "/categories/:id/edit",
        element: <Categories />,
    },
    {
        path: "/categories/:id",
        element: <Categories />,
    },
    {
        path: "/services",
        element: <Service />,
    },
     {
        path: "/services/add",
        element: <Service />,
    },
     {
        path: "/services/:id",
        element: <Service />,
    },
    {
        path: "/banners",
        element: <BannerManagement />
    },
     {
        path: "/banners/add",
        element: <BannerManagement />
    },
     {
        path: "/banners/:id",
        element: <BannerManagement />
    },
    {
        path: "/banners/:id/edit",
        element: <BannerManagement />
    },
    {
        path: "/coupons",
        element: <CouponManagement />
    },
    {
        path: "/Subcategories",
        element: <Subcategory />
    },
    {
        path: "/Subcategories/add",
        element: <Subcategory />
    },
    {
        path: "/Subcategory/:id/edit",
        element: <Subcategory />
    },
    {
        path: "/Subcategories/:id",
        element: <Subcategory />
    },
    {
        path: "/customers",
        element: <Customermanagement />
    },
     {
        path: "/customers/add",
        element: <Customermanagement />
    },
    {
        path: "/customer/:id",
        element: <CustomerDetails />
    },
     {
        path: "/customers/:id",
        element: <Customermanagement />
    },
       {
        path: "/customer/:id/edit",
        element: <Customermanagement />
    },
    {
        path: "/bookings",
        element: <Bookings />
    },
    {
        path: "/bookings/:id",
        element: <BookingDetails />
    },
    {
        path: "/providers/:providerId/view",
        element: <BookingsWrapper />
    },
    {
        path: "/providers/:providerId/edit",
        element: <ProviderFormWrapper />
    },
     {
        path: "/providers/:id",
        element: <Providers/>
    },
    {
        path: "/providers/add",
        element: <ProviderFormWrapper />
    },
    {
        path: "/providers",
        element: <Providers />
    },
    {
        path:"/payments",
        element:<PaymentManagement/>
    }

];


export const AuthRoutes: DtoRoutesDefinition[] = [

    {
        path: "/",
        element: <LoginPage />
    },
    // {
    //     path: "/sign-in",
    //     element: <LoginPage />
    // },
    {
        path: "/signup",
        element: <UserSignUp />
    },
    {
        path: "/set-password",
        element: <></>
    },
];
